// src/constants/navItems.js with Debug menu removed
import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import GppGoodIcon from '@mui/icons-material/GppGood';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import SettingsIcon from '@mui/icons-material/Settings';

const navItems = [
  {
    text: 'Home',
    icon: <HomeIcon fontSize="large" />,
    path: null, // Home doesn't need a path
  },
  {
    text: 'Health & Safety Policy Manual',
    icon: <HealthAndSafetyIcon fontSize="large" />,
    path: 'Firebase_upload/Master Vehicle File/1. Health & Safety Policy Manual',
  },
  {
    text: 'Insurance Certificates',
    icon: <MenuBookIcon fontSize="large" />,
    path: 'Firebase_upload/Master Vehicle File/2. Insurance Certificates',
  },
  {
    text: 'COSHH',
    icon: <GppGoodIcon fontSize="large" />,
    path: 'Firebase_upload/Master Vehicle File/3. COSHH',
  },
  {
    text: 'Risk Assessments',
    icon: <ReportProblemIcon fontSize="large" />,
    path: 'Firebase_upload/Master Vehicle File/4. Risk Assessments',
  },
  {
    text: 'Safe Systems of Work',
    icon: <GppGoodIcon fontSize="large" />,
    path: 'Firebase_upload/Master Vehicle File/5. Safe Systems of Work',
  },
  {
    text: 'Employee Handbook',
    icon: <MenuBookIcon fontSize="large" />,
    path: 'Firebase_upload/Master Vehicle File/6. Employee Handbook',
  },
  {
    text: 'Settings',
    icon: <SettingsIcon fontSize="large" />,
    screen: 'settings',
  },
];

export default navItems;